import { createSlice, current } from "@reduxjs/toolkit";
import {setNewUserProperty} from "../analytics/ClevetapService";

const initialState = {
  value: {
    tokenid: "",
    selectedmsisdn: "",
    loginmode: "",
    rateplantype: "",
    customerprofile: {},
    balancedata: {},
    keyValueTransferCredit: '',
    rnuserdetails: {},
    linedetails: {},
    passportlist: [],
    CTpayObject: {},
    CTPurchaseObject: {},
    paymenttype: "",
    NojoomRewardPoints: "",
    NojoomMemberNumber: "",
    SelectedMenu: "home/index",
    // SelectedMenuPrev: "home/index",
    NojoomPrimaryNumber: "",
    QueryAccountLinkedMsisdn: {},
    ChildMsisdn: "",
    isB2BCPRNumber: "",
    isWifiCase:false, 
    GTMLoginFlag: false,
    socialLoginType: "",
    GTMSingUPFlag: false,
    GTMWifiLoginFlag: true,
    Isratinggiven:"",
    isPaciLogin: false,
    purchaseData: {},
    newUserProperties: [],
    langrx: '',
    isViewPacks: false,
    alertTypeList: []
  },
  recharge: {
    continuClicked: false,
    rechargeNumbersList: [],
    totalAmount: 0,
    rndenominations: [],
    defaultprepaiddata: {},
    rnnumberslist: [],
    selectednumbers: [],
    errorForANumber: {
      message: "",
      msisdn: "",
    },
    rnNumbersRawList: [],
    roamingMultilevelData: null,
    dueamount: "",
    mynumbersselectedstatus: {
      allPrepaidSelected: false,
      allPostpaidSelected: false,
      allAddedSelected: false,
    },
    myNumbersSelectedStatus:{
      allPrepaidSelected: false,
      allPostpaidSelected: false,
      allAddedSelected: false,
    }
  },
  signup: {
    signupnumber: "",
  },
  otptransid: "",
  netData: null,
  savedCardData: null,
  selectedCardData: null,
  dashboardRecommendations: null,
  carouselBannerBgColor: '',
  headerTitleColor: '',
  isDefaultCarouselBanner: false,
  showNotificationGreetingSection: true,
  notificationsArray: [],
  notificationData: null,
  notificationAlert: true,
  cvmRecommendationsData: null,
  isDefaultCarouselBanner: false,
  userLoggedInNumber: ''
};
export const userSlice = createSlice({
  name: "userdata",
  initialState,
  reducers: {
    settoken: (state, action) => {
      // console.log("------------settoken", action.payload);
      state.value.tokenid = action.payload;
    },

    setclear: (state, action) => {
      // console.log("------------setvalue clear", action.payload);
      state.value.tokenid = "";
    },
    setSelectedNumber: (state, action) => {
      // console.log("------------selectedmsisdn", action.payload);
      state.value.selectedmsisdn = action.payload;
    },
    setLoginType: (state, action) => {
      state.value.loginmode = action.payload;
    },
    setRatePlanType: (state, action) => {
      state.value.rateplantype = action.payload;
    },
    setCTPayObject: (state, action) => {
      state.value.CTpayObject = action.payload;
    },
    setCTPurchaseObject: (state, action) => {
      state.value.CTPurchaseObject = action.payload;
    },
    setPaymentType: (state, action) => {
      state.value.paymenttype = action.payload;
    },
    setSelectedMenu: (state, action) => {
      state.value.SelectedMenu = action.payload;
    },
    // setSelectedMenuPrev: (state, action) => {
    //   state.value.SelectedMenuPrev = action.payload;
    // },
    setcustomerprofile: (state, action) => {
      state.value.customerprofile = action.payload;
    },
    setNojoomRewardPoints: (state, action) => {
      state.value.NojoomRewardPoints = action.payload;
    },
    setNojoomMemberNumber: (state, action) => {
      state.value.NojoomMemberNumber = action.payload;
    },
    setNojoomPrimaryNumber: (state, action) => {
      state.value.NojoomPrimaryNumber = action.payload;
    },
    setISB2BCPRNumber: (state, action) => {
      state.value.isB2BCPRNumber = action.payload;
    },
    setIsWifiCase: (state, action) => {
      state.value.isWifiCase = action.payload;
    },
    setrnuserdetails: (state, action) => {
      state.value.rnuserdetails = action.payload;
    },
    setlinedetails: (state, action) => {
      state.value.linedetails = action.payload;
    },
    setbalancedata: (state, action) => {
      state.value.balancedata = action.payload;
    },
    setkeyValueTransferCredit: (state, action) => {
      state.value.keyValueTransferCredit = action.payload;
    },
    setpassportlist: (state, action) => {
      state.value.passportlist = action.payload;
    },
    setrechargeNumbersList: (state, action) => {
      state.recharge.rechargeNumbersList = action.payload;
      const totalAmount = action.payload.reduce((accumulator, object) => {
        return accumulator + (parseFloat(object.amount) || 0);
      }, 0);
      state.recharge.totalAmount = totalAmount;
    },
    setrechargenumber: (state, action) => {
      const { index, value } = action.payload;
      const list = [...state.recharge.rechargeNumbersList];
      list[index].msisdn = value;
      state.recharge.rechargeNumbersList = list;
    },
    setrechargeamount: (state, action) => {
      const { index, value } = action.payload;
      const list = [...state.recharge.rechargeNumbersList];
      if (list[index]) list[index].amount = value;
      state.recharge.rechargeNumbersList = list;
      const totalAmount = list.reduce((accumulator, object) => {
        return accumulator + (parseFloat(object?.amount || "0") || 0);
      }, 0);
      state.recharge.totalAmount = totalAmount;
    },
    deleterechargenumber: (state, action) => {
      const index = action.payload;
      const list = JSON.parse(
        JSON.stringify(state.recharge.rechargeNumbersList)
      );
      const msisdn = list[index]?.msisdn;
      if (msisdn?.length && state.recharge.selectednumbers?.length) {
        const selectedNumbers = [...state.recharge.selectednumbers];
        const selectedIndex = selectedNumbers.findIndex(
          (item) => item.msisdn === msisdn
        );
        selectedNumbers.splice(selectedIndex, 1);
        state.recharge.selectednumbers = selectedNumbers;
      }
      list.splice(index, 1);
      state.recharge.rechargeNumbersList = list;
      const totalAmount = list.reduce((accumulator, object) => {
        return accumulator + (parseFloat(object?.amount || "0") || 0);
      }, 0);
      state.recharge.totalAmount = totalAmount;
    },
    setrndenominations: (state, action) => {
      state.recharge.rndenominations = action.payload;
    },
    setdefaultprepaiddata: (state, action) => {
      state.recharge.defaultprepaiddata = action.payload;
    },
    setrnnumberslist: (state, action) => {
      state.recharge.rnnumberslist = action.payload;
    },
    setselectednumbers: (state, action) => {
      const { data, selected } = action.payload;
      const { msisdn } = data;
      const list = state.recharge.selectednumbers?.length
        ? JSON.parse(JSON.stringify(state.recharge.selectednumbers))
        : [];
      const listrecharge = [...state.recharge.rechargeNumbersList];
      if (selected) list.push(data);
      else {
        const _msisdn = "965" + msisdn;
        const indexrecharge = listrecharge.findIndex(
          (item) => item.msisdn === _msisdn
        );
        const index = list.findIndex((item) => item.msisdn === msisdn);
        if (index >= 0) list.splice(index, 1);
        if (indexrecharge >= 0) listrecharge.splice(indexrecharge, 1);
        state.recharge.rechargeNumbersList = listrecharge;
      }
      if (state?.recharge?.mynumbersselectedstatus) {
        if (
          selected &&
          list?.filter((item) => !item.prepaid)?.length > 0 &&
          list?.filter((item) => !item.prepaid)?.length ===
          state.recharge.rnnumberslist?.filter(
            (item) => item.msisdntype?.toUpperCase() === "POSTPAID"
          )?.length
        ) {
          state.recharge.mynumbersselectedstatus.allPostpaidSelected = true;
        } else {
          state.recharge.mynumbersselectedstatus.allPostpaidSelected = false;
        }
      }
      if (state?.recharge?.mynumbersselectedstatus) {
        if (
          selected &&
          list?.filter((item) => item.prepaid)?.length > 0 &&
          list?.filter((item) => item.prepaid)?.length ===
          state.recharge.rnnumberslist?.filter(
            (item) =>
              item.msisdntype?.toUpperCase() === "PREPAID" ||
              item.msisdntype?.toUpperCase() === "ANA"
          )?.length
        ) {
          state.recharge.mynumbersselectedstatus.allPrepaidSelected = true;
        } else {
          state.recharge.mynumbersselectedstatus.allPrepaidSelected = false;
        }
      }
      if (state?.recharge?.mynumbersselectedstatus) {
        if (
          selected &&
          list?.filter((item) => item.addedNumber)?.length > 0 &&
          list?.filter((item) => item.addedNumber)?.length ===
          state.recharge.rnnumberslist?.filter(
            (item) => item.NonAccountMsisdn
          )?.length
        ) {
          state.recharge.mynumbersselectedstatus.allAddedSelected = true;
        } else {
          state.recharge.mynumbersselectedstatus.allAddedSelected = false;
        }
      }
      state.recharge.selectednumbers = list;
    },
    resetselectednumbers: (state, action) => {
      state.recharge.selectednumbers = [];
    },
    setRnNumbersRawList: (state, action)=>{
      state.recharge.rnNumbersRawList = action.payload;
    },
    setChildMsisdn: (state, action) => {
      state.value.ChildMsisdn = action.payload
    },
    setallselectednumbers: (state, action) => {
      if (action.payload) {
        if (state?.recharge?.myNumbersSelectedStatus) {
          state.recharge.myNumbersSelectedStatus.allAddedSelected = true;
          state.recharge.myNumbersSelectedStatus.allPrepaidSelected = true;
          state.recharge.myNumbersSelectedStatus.allPostpaidSelected = true;
        }
        state.recharge.selectednumbers = [...state.recharge.rnNumbersRawList]?.map(
          (item) => {
            return {
              msisdn: item?.msisdn,
              amount:
                item.msisdntype?.toUpperCase() === "PREPAID" ||
                  item.msisdntype?.toUpperCase() === "ANA"
                  ? parseInt(item?.balance) < 0
                    ? "0"
                    : item?.balance
                  : parseInt(item?.dueamount) < 0
                    ? "0"
                    : item?.dueamount,
              selected: true,
              prepaid:
                item.msisdntype?.toUpperCase() === "PREPAID" ||
                item.msisdntype?.toUpperCase() === "ANA",
              addedNumber: item.NonAccountMsisdn || false,
            };
          }
        );
        console.log(
          state.recharge.selectednumbers,
          "state.recharge.selectednumbers"
        );
      } else {
        state.recharge.selectednumbers = [];
        if (state?.recharge?.myNumbersSelectedStatus) {
          state.recharge.myNumbersSelectedStatus.allAddedSelected = false;
          state.recharge.myNumbersSelectedStatus.allPrepaidSelected = false;
          state.recharge.myNumbersSelectedStatus.allPostpaidSelected = false;
        }
      }
    },
    setprepaidselectednumbers: (state, action) => {
      if (action.payload) {
        const allPrepaidList = [...state.recharge.rnNumbersRawList]
          ?.filter(
            (item) =>
              item.msisdntype?.toUpperCase() === "PREPAID" ||
              item.msisdntype?.toUpperCase() === "ANA"
          )
          .filter(
            (item) =>
              state.recharge.selectednumbers.findIndex(
                (item2) => item2.msisdn === item.msisdn
              ) < 0
          )
          ?.map((item) => {
            return {
              msisdn: item?.msisdn,
              amount: parseInt(item?.balance) < 0 ? "0" : item?.balance,
              selected: true,
              prepaid: true,
              addedNumber: item.NonAccountMsisdn || false,
            };
          });
        state.recharge.selectednumbers = [
          ...state.recharge.selectednumbers,
          ...allPrepaidList,
        ];
      } else {
        state.recharge.selectednumbers = state.recharge.selectednumbers.filter(
          (item) => !item.prepaid || item.addedNumber
        );
      }
      if (state?.recharge?.myNumbersSelectedStatus) {
        if (action.payload) {
          state.recharge.myNumbersSelectedStatus.allPrepaidSelected = true;
        } else {
          state.recharge.myNumbersSelectedStatus.allPrepaidSelected = false;
        }
      }
    },
    setpostpaidselectednumbers: (state, action) => {
      if (action.payload) {
        const allPostpaidList = [...state.recharge.rnNumbersRawList]
          ?.filter((item) => item.msisdntype?.toUpperCase() === "POSTPAID")
          .filter(
            (item) =>
              state.recharge.selectednumbers.findIndex(
                (item2) => item2.msisdn === item.msisdn
              ) < 0
          )
          ?.map((item) => {
            return {
              msisdn: item?.msisdn,
              amount: parseInt(item?.dueamount) < 0 ? "0" : item?.dueamount,
              selected: true,
              prepaid: false,
              addedNumber: item.NonAccountMsisdn || false,
            };
          });
        state.recharge.selectednumbers = [
          ...state.recharge.selectednumbers,
          ...allPostpaidList,
        ];
      } else {
        state.recharge.selectednumbers = state.recharge.selectednumbers.filter(
          (item) => item.prepaid || item.addedNumber
        );
      }
      if (state?.recharge?.myNumbersSelectedStatus) {
        if (action.payload) {
          state.recharge.myNumbersSelectedStatus.allPostpaidSelected = true;
        } else {
          state.recharge.myNumbersSelectedStatus.allPostpaidSelected = false;
        }
      }
    },
    setaddedselectednumbers: (state, action) => {
      if (action.payload) {
        const allAddedNumbersList = [...state.recharge.rnNumbersRawList]
          ?.filter((item) => item.NonAccountMsisdn)
          ?.filter(
            (item) =>
              state.recharge.selectednumbers.findIndex(
                (item2) => item2.msisdn === item.msisdn
              ) < 0
          )
          ?.map((item) => {
            return {
              msisdn: item?.msisdn,
              amount: parseInt(item?.balance) < 0 ? "0" : item?.balance,
              selected: true,
              prepaid:
                item?.msisdntype?.toUpperCase() === "PREPAID" ||
                item?.msisdntype?.toUpperCase() === "ANA",
              addedNumber: item.NonAccountMsisdn,
            };
          });
        state.recharge.selectednumbers = [
          ...state.recharge.selectednumbers,
          ...allAddedNumbersList,
        ];
      } else {
        state.recharge.selectednumbers = state.recharge.selectednumbers.filter(
          (item) => !item.addedNumber
        );
      }
      if (state?.recharge?.myNumbersSelectedStatus) {
        if (action.payload) {
          state.recharge.myNumbersSelectedStatus.allAddedSelected = true;
        } else {
          state.recharge.myNumbersSelectedStatus.allAddedSelected = false;
        }
      }
    },
    addselectednumbersinlist: (state, action) => {
      let list = current(state.recharge.rechargeNumbersList);
      const selectedNumbers = current(state.recharge.selectednumbers).map(
        (item) => ({
          ...item,
          amount: item.prepaid ?
           (state.recharge.defaultprepaiddata?.defaultamount !== null || state.recharge.defaultprepaiddata?.defaultamount !== undefined || state.recharge.defaultprepaiddata?.defaultamount !== ''? state.recharge.defaultprepaiddata?.defaultamount : 0) : 
           item.amount !== null ? item.amount : 0,
        })
      );
      const onlyAnotherNumbersList = list.filter((item) => item?.another);
      // const selectedNumbersNotInList = selectedNumbers
      //   .filter(
      //     (item) => list?.findIndex((item2) => item2.msisdn === item.msisdn) < 0
      //   )
      //   .map((item) => {
      //     const index = list?.findIndex(
      //       (item2) => item2.msisdn === item.msisdn
      //     );
      //     return {
      //       ...item,
      //       amount: index >= 0 ? list[index]?.amount : item?.amount,
      //     };
      //   });
      const finalList = selectedNumbers
      // const finalList = onlyAnotherNumbersList?.concat(
      //   selectedNumbersNotInList?.length
      //     ? selectedNumbersNotInList
      //     : selectedNumbers
      // );
      const totalAmount = finalList.reduce((accumulator, object) => {
        return accumulator + (parseFloat(object?.amount) || 0);
      }, 0);
      state.recharge.totalAmount = totalAmount;
      state.recharge.rechargeNumbersList = finalList;
      console.log(state.recharge.rechargeNumbersList, "finalList");
    },
    setpreviousselectednumbers: (state, action) => {
      state.recharge.selectednumbers = action.payload;
    },
    setErrorForANumber: (state, action) => {
      state.recharge.errorForANumber = action.payload;
    },
    resetUserData: () => initialState,
    setRoamingMultilevelData: (state, action) => {
      state.value.roamingMultilevelData = action.payload;
    },
    setotptransid: (state, action) => {
      state.otptransid = action.payload;
    },
    setsignupnumber: (state, action) => {
      state.signup.signupnumber = action.payload;
    },
    setdueamount: (state, action) => {
      try{
      state.recharge.dueamount = action.payload;
      }
      catch(e){console.log("setdueamount set error:"+e+"")}
    },
    setallprepaidtoggle: (state, action) => {
      state.recharge.mynumbersselectedstatus.allPrepaidSelected =
        action.payload;
    },
    setallpostpaidtoggle: (state, action) => {
      state.recharge.mynumbersselectedstatus.allPostpaidSelected =
        action.payload;
    },
    setalladdedtoggle: (state, action) => {
      state.recharge.mynumbersselectedstatus.allAddedSelected = action.payload;
    },
    setContinueClicked: (state, action) => {
      state.recharge.continuClicked = action.payload;
    },
    setNetData: (state, action) => {
      state.netData = action.payload
    },
    setQueryAccountLinkedMsisdn: (state, action) => {
      state.value.globalData = action.payload;
    },
    setSavedCardData: (state, action) => {
      state.savedCardData = action.payload
    },
    setSelectedCardData: (state, action) => {
      state.selectedCardData = action.payload
    },
    setDashboardRecommendations: (state, action) => {
      state.dashboardRecommendations = action.payload;
    },
    setGTMLoginFlag: (state, action) =>{
      state.value.GTMLoginFlag = action.payload
    }, 
    setSocialLoginType: (state, action) =>{
      state.value.socialLoginType = action.payload;
    },
    setGTMSingUPFlag: (state, action) =>{
      state.value.GTMSingUPFlag = action.payload;
    },
    setGTMWifiLoginFlag: (state, action) =>{
      state.value.GTMWifiLoginFlag = action.payload
    },
    setIsRatingGiven: (state, action) =>{
      state.value.Isratinggiven = action.payload
    },
    setCarouselBannerBgColor: (state, action) => {
      state.carouselBannerBgColor = action.payload;
    },
    setHeaderTitleColor: (state, action) => {
      state.headerTitleColor = action.payload;
    },
    setIsDefaultCarouselBanner: (state, action) => {	
      state.isDefaultCarouselBanner = action.payload;	
    },
    setShowNotificationGreetingSection: (state, action) => {
      state.showNotificationGreetingSection = action.payload;
    },
    setIsPaciLogin: (state, action) =>{
      state.value.isPaciLogin = action.payload
    },
    setPurchaseData: (state, action) =>{
      state.value.purchaseData = action.payload;
    },
    setNotificationData: (state, action) =>{
      state.notificationData = action.payload;
    },
    setNotificationsArray: (state, action)=> {
      if(action.payload == "clearNotification"){
        state.notificationsArray = [];
      }
      else if(action.payload?.type == "delete"){
        for(var i in current(state.notificationsArray)){
          if(current(state.notificationsArray)[i]?.data === action?.payload?.data){
            state.notificationsArray?.splice(i, 1);
            const originalList = state.value.alertTypeList ? state.value.alertTypeList : [];
            state.value.alertTypeList = [...originalList, action?.payload?.data?.notificationtype]
          }
        }
      }
      else if(!state.value.alertTypeList?.includes(action?.payload?.data?.notificationtype)){
        if(state?.notificationsArray?.length >0){

          let temp = state?.notificationsArray.map(item => item?.type);

          if(temp?.includes(action?.payload?.type)){
            for(var i in state?.notificationsArray){
              if(state?.notificationsArray[i]?.type === action?.payload?.type){
                state.notificationsArray[i].type = action?.payload?.type;
                state.notificationsArray[i].data = action?.payload?.data
              }
            }
          }else{
              state.notificationsArray =[ ...state.notificationsArray, {
                type: action?.payload?.type,
                data: action?.payload?.data
                }];
            }
      }
      else{
        state.notificationsArray = [action?.payload]
        }
      }
    },
    setNewUserProperties: (state, action) =>{
      if(state?.value?.newUserProperties?.length >0){

        let temp = state?.value?.newUserProperties?.map(item => item?.type);

        if(!temp?.includes(action?.payload?.type)){
          setNewUserProperty(action?.payload?.type, action?.payload?.data);
            state.value.newUserProperties =[ ...state.value?.newUserProperties, {
                type: action?.payload?.type,
                data: action?.payload?.data
              }];
          }
      }
      else{
        setNewUserProperty(action?.payload?.type, action?.payload?.data);
        state.value.newUserProperties = [action?.payload];
      }
    },
    setShowNotification: (state, action) =>{
      state.notificationAlert = action.payload;
    },
    setCvmRecommendationsData: (state, action) => {
      state.cvmRecommendationsData = action.payload
    },
    setQueryAccountData: (state, action) => {	
      state.queryAccountData = action.payload	
    },
    setLangrx: (state, action) => {
      state.value.langrx = action.payload;
    },
    setIsViewPacks: (state, action) =>{
      state.value.isViewPacks = action.payload;
    },
    setAlertTypeList: (state, action)=>{
      state.value.alertTypeList = action.payload;
    },
    setUserLoggedInNumber: (state, action)=>{ // user logged in number it will not be updated with child msisdn 
      state.userLoggedInNumber = action.payload;
    }
  },
});

export const {
  settoken,
  setSelectedNumber,
  setLoginType,
  setRatePlanType,
  setCTPayObject,
  setCTPurchaseObject,
  setPaymentType,
  setNojoomRewardPoints,
  setNojoomMemberNumber,
  setNojoomPrimaryNumber,
  setclear,
  setcustomerprofile,
  setrnuserdetails,
  setbalancedata,
  setlinedetails,
  setpassportlist,
  setrechargeNumbersList,
  setrechargenumber,
  setrechargeamount,
  deleterechargenumber,
  setrndenominations,
  setdefaultprepaiddata,
  setrnnumberslist,
  setRnNumbersRawList,
  setselectednumbers,
  resetselectednumbers,
  setallselectednumbers,
  setprepaidselectednumbers,
  setpostpaidselectednumbers,
  setaddedselectednumbers,
  addselectednumbersinlist,
  setpreviousselectednumbers,
  setErrorForANumber,
  resetUserData,
  setRoamingMultilevelData,
  setotptransid,
  setsignupnumber,
  setdueamount,
  setallprepaidtoggle,
  setallpostpaidtoggle,
  setalladdedtoggle,
  setContinueClicked,
  setSelectedMenu,
  // setSelectedMenuPrev,
  setSelectedMenuPrev,
  setNetData,
  setQueryAccountLinkedMsisdn,
  setChildMsisdn,
  setkeyValueTransferCredit,
  setSavedCardData,
  setSelectedCardData,
  setISB2BCPRNumber,
  setIsWifiCase,
  setDashboardRecommendations,
  setGTMLoginFlag, 
  setSocialLoginType,
  setGTMSingUPFlag,
  setGTMWifiLoginFlag,
  setIsRatingGiven,
  setCarouselBannerBgColor,
  setHeaderTitleColor,
  setIsDefaultCarouselBanner,
  setShowNotificationGreetingSection,
  setIsPaciLogin,
  setPurchaseData,
  setNotificationData, 
  setNotificationsArray,
  setShowNotification,
  setCvmRecommendationsData,
  setNewUserProperties,
  setQueryAccountData,
  setLangrx, 
  setIsViewPacks,
  setAlertTypeList,
  setUserLoggedInNumber
} = userSlice.actions;
export default userSlice.reducer;
